import React from 'react';
import type { FormBuilderStore } from 'controls/react/form/formBuilderNew/formBuilderStore';

export const FormBuilderContext = React.createContext<FormBuilderStore>(null);
